import { OrderLineItem } from '../../queries/shopify/fragments/OrderLineItems';
import sendEmail from '../../queries/email/sendEmail';
import generateEmailContent from './generateEmailContent';
import useSendEmail from '../../queries/email/sendEmail';

type SendOrderToCustomer = {
  orderName: string;
  items: OrderLineItem[];
  total: string;
  note: string;
  customerEmail: string;
  customerName: string;
}

const useSendOrderToCustomer = () => {
  const sendEmail = useSendEmail();
  return ({
    orderName,
    items,
    total,
    note,
    customerEmail,
    customerName,
  }: SendOrderToCustomer) => async (shipDate: Date, prevSentTime: number) => {
    const subject = prevSentTime
      ? `Order ${orderName} delivery date was changed`
      : `Your MK Socks Order ${orderName}`;
    const content = generateEmailContent(
      orderName,
      customerName,
      shipDate,
      prevSentTime,
      items,
      total,
      note,
    );

    try {
      const res = await sendEmail([customerEmail], subject, content);
      console.info('Sent customer email:', subject, customerEmail, res.success);
      return { result: res.success, email: customerEmail };
    } catch (e) {
      console.warn(
        'Failed to send customer email:',
        subject,
        customerEmail,
        e.message,
      );
      throw { error: e.message, email: customerEmail };
    }
  };
};

export default useSendOrderToCustomer;
